export const NBA_COURT_POSITIONS = {
  C: { x: 50, y: 22 },
  PF: { x: 30, y: 32 },
  SF: { x: 78, y: 46 },
  SG: { x: 22, y: 50 },
  PG: { x: 50, y: 74 },
};

export const NFL_FIELD_POSITIONS = {
  FS: { x: 50, y: 8 },
  SS: { x: 68, y: 14 },
  LCB: { x: 12, y: 18 },
  RCB: { x: 88, y: 18 },
  WLB: { x: 32, y: 26 },
  MLB: { x: 50, y: 24 },
  SLB: { x: 68, y: 26 },
  LDE: { x: 28, y: 39 },
  LDT: { x: 42, y: 39 },
  RDT: { x: 58, y: 39 },
  RDE: { x: 72, y: 39 },
  WR: { x: 10, y: 50 },
  WR2: { x: 90, y: 50 },
  TE: { x: 80, y: 52 },
  LT: { x: 30, y: 52 },
  LG: { x: 40, y: 52 },
  C: { x: 50, y: 52 },
  RG: { x: 60, y: 52 },
  RT: { x: 70, y: 52 },
  QB: { x: 50, y: 68 },
  RB: { x: 50, y: 80 },
  K: { x: 22, y: 94 },
  P: { x: 50, y: 94 },
  RET: { x: 78, y: 94 },
};

export const NFL_LINE_OF_SCRIMMAGE_Y = 45;

export const NFL_FIELD_LABELS = {
  defense: { x: 4, y: 16 },
  offense: { x: 4, y: 60 },
};

export const FIELD_ASPECT = {
  mlb: "1",
  nba: "1",
  nfl: "3 / 4",
};

export const FIELD_SURFACE = {
  mlb: "#10140f",
  nba: "#1c1610",
  nfl: "#0d1610",
};

export const slotPointSx = (point) => {
  if (!point) return null;
  return {
    position: "absolute",
    zIndex: 1,
    left: `${point.x}%`,
    top: `${point.y}%`,
    transform: "translate(-50%, -50%)",
  };
};

export const NFL_SPECIAL_SLOT_IDS = ["K", "P", "RET"];

export const NFL_DEFENSE_SLOT_IDS = [
  "LDE",
  "LDT",
  "RDT",
  "RDE",
  "WLB",
  "MLB",
  "SLB",
  "LCB",
  "RCB",
  "FS",
  "SS",
];

export const getSportFieldPositions = (sport) => {
  if (sport === "nba") return NBA_COURT_POSITIONS;
  if (sport === "nfl") return NFL_FIELD_POSITIONS;
  return null;
};

export const groupSlotsForCompact = (sport, slots = []) => {
  if (sport !== "nfl") return [{ id: "all", label: null, slots }];
  const defense = new Set(NFL_DEFENSE_SLOT_IDS);
  const special = new Set(NFL_SPECIAL_SLOT_IDS);
  const offenseSlots = slots.filter(
    (slot) => !defense.has(slot.id) && !special.has(slot.id)
  );
  const defenseSlots = slots.filter((slot) => defense.has(slot.id));
  const specialSlots = slots.filter((slot) => special.has(slot.id));
  const groups = [];
  if (offenseSlots.length) groups.push({ id: "offense", label: "Offense", slots: offenseSlots });
  if (defenseSlots.length) groups.push({ id: "defense", label: "Defense", slots: defenseSlots });
  if (specialSlots.length) {
    groups.push({ id: "special", label: "Special teams", slots: specialSlots });
  }
  return groups.length ? groups : [{ id: "all", label: null, slots }];
};

export const lineupSectionId = (groupId, prefix = "") =>
  `lineup-${prefix ? `${prefix}-` : ""}${groupId}`;
